import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Footer({ onDonate }) {
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-navy text-white pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Final CTA strip */}
        <div className="bg-gradient-to-r from-brand-coral to-orange-500 rounded-3xl p-8 md:p-14 mb-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/80 mb-3">
              Last chance on this page
            </div>
            <h3 className="font-display font-black text-3xl md:text-5xl leading-[1.05] tracking-tight max-w-2xl">
              Put one more kid in our program this month.
            </h3>
          </div>
          <Button
            data-testid="footer-donate-btn"
            onClick={onDonate}
            size="lg"
            className="rounded-full bg-white text-brand-coral hover:bg-brand-navy hover:text-white font-bold px-10 h-14 text-base shadow-xl hover:-translate-y-1 transition-all flex-shrink-0"
          >
            <Heart className="w-5 h-5 mr-2 fill-brand-coral" />
            Donate today
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <Link to="/" className="inline-block mb-5">
              <img
                src="/hero/logo-p2f.png?v=3"
                alt="Play 2 Fitness"
                className="h-20 w-auto object-contain"
              />
            </Link>
            <p className="text-slate-400 leading-relaxed max-w-md">
              A 501(c)(3) nonprofit empowering Inland Empire youth
              through daily fitness, academics, mentorship, and career pathways.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-4">
              Explore
            </div>
            <ul className="space-y-3 text-slate-300">
              <li><a className="hover:text-white" href="#mission">Mission</a></li>
              <li><a className="hover:text-white" href="#program">The Program</a></li>
              <li><a className="hover:text-white" href="#impact">Impact</a></li>
              <li><a className="hover:text-white" href="#involved">Get Involved</a></li>
              <li><a className="hover:text-white" href="#about">About</a></li>
              <li><a className="hover:text-white" href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-4">
              Visit &amp; connect
            </div>
            <ul className="space-y-2 text-slate-300">
              <li>10950 Arrow Route #1203</li>
              <li>Rancho Cucamonga, CA 91729</li>
              <li className="pt-2">Karlynncammon@play2fitness.com</li>
              <li>Mon–Fri · 3:00 – 6:00 PM</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm text-slate-400">
          <div>© {new Date().getFullYear()} Play 2 Fitness. All rights reserved.</div>
          <div>501(c)(3) nonprofit · EIN available upon request</div>
        </div>
      </div>
    </footer>
  );
}
